import { setContext } from "apollo-link-context";
import LogRocket from "logrocket";
import { isProduction } from "@/utils/constants";

const unsubscribedPath = window?.location?.pathname === "/unsubscribed";
let recordingURL = "";

// Setup LogRocket URL
if (isProduction && !unsubscribedPath) {
  LogRocket.getSessionURL(function (sessionURL) {
    recordingURL = sessionURL;
  });
}

export default getAccessToken =>
  setContext(async (_, { headers }) => {
    // get the authentication token from local storage if it exists
    const accessToken = getAccessToken();

    // return the headers to the context so httpLink can read them...
    return {
      headers: {
        ...headers,
        authorization: accessToken ? accessToken : "",
        "X-LogRocket-URL": recordingURL
      }
    };
  });
